/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown>, range: NonNullable<unknown> }} My_Grower_Report_Chart_LabelInputs */

const vi_my_grower_report_chart_label = /** @type {(inputs: My_Grower_Report_Chart_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Biểu đồ ${i?.title}, ${i?.range}`)
};

/**

* @param {My_Grower_Report_Chart_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_chart_label = /** @type {((inputs: My_Grower_Report_Chart_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Chart_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_chart_label(inputs)
});